const search = {
  kind: 1,
  ticketNo: "",
  identityNo: "",
  code: "",
}

export default search
